function revealSections(root = document) {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
  const items = root.querySelectorAll('[data-mm-reveal]:not(.mm-will-reveal)');
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('mm-revealed');
      observer.unobserve(entry.target);
    });
  }, { threshold: 0.08 });
  items.forEach(item => { item.classList.add('mm-will-reveal'); observer.observe(item); });
}
revealSections();
document.addEventListener('shopify:section:load', event => revealSections(event.target));
